import { render, staticRenderFns } from "./itemoptionview.vue?vue&type=template&id=3bb384a3&scoped=true&"
import script from "./itemoptionview.vue?vue&type=script&lang=js&"
export * from "./itemoptionview.vue?vue&type=script&lang=js&"
import style0 from "./itemoptionview.vue?vue&type=style&index=0&id=3bb384a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb384a3",
  null
  
)

export default component.exports